/* ===================================================================
   Barrel for the Rhody Reviews api/v1 client.

   GATE-PREP SPLIT (2026): the former single src/lib/api.ts was split into
   a shared HTTP/token layer (./_http) plus one module per domain
   (./reviews, ./customers, ...). This barrel re-exports everything those
   modules export and re-assembles the single `api` object, so every
   existing importer (`import { api, ApiError, ... } from '../lib/api'`)
   keeps working with ZERO changes. Adding a feature lane later =
   create ./<lane>.ts exporting `<lane>Api` + its types, then add one
   `export * from './<lane>'` line + one spread into `api` below.

   PURE REFACTOR: no request path, method, body, type, or runtime
   behavior changed in the split.
   =================================================================== */

// Shared HTTP + token layer (request, ApiError, token store, base URLs).
export * from './_http';

// Side-effect import: installs the 401 recovery hook (transparent rr_ token
// re-mint + auto-retry, or sign-out on a dead session). Must run so request()'s
// registered refresher is non-null by the time any data call fires.
import './reauth';

// Per-domain types + the domain method objects.
export * from './core';
export * from './google';
export * from './reviews';
export * from './customers';
export * from './requests';
export * from './notifications';
export * from './templates';
export * from './automations';
export * from './account';
export * from './widget';
export * from './missed_call';
export * from './competitors';
export * from './analytics';
export * from './review_mining';
export * from './integrations';
export * from './social';
export * from './admin';
export * from './billing';
export * from './feedback_board';
export * from './sms_optin';
export * from './gbpPosts';
export * from './gbpImages';
export * from './locations';

import { coreApi } from './core';
import { googleApi } from './google';
import { reviewsApi } from './reviews';
import { customersApi } from './customers';
import { requestsApi } from './requests';
import { notificationsApi } from './notifications';
import { templatesApi } from './templates';
import { automationsApi } from './automations';
import { accountApi } from './account';
import { widgetApi } from './widget';
import { missedCallApi } from './missed_call';
import { competitorsApi } from './competitors';
import { analyticsApi } from './analytics';
import { reviewMiningApi } from './review_mining';
import { integrationsApi } from './integrations';
import { socialApi } from './social';
import { adminApi } from './admin';
import { billingApi } from './billing';
import { feedbackBoardApi } from './feedback_board';
import { smsOptInApi } from './sms_optin';
import { gbpPostsApi } from './gbpPosts';
import { gbpImagesApi } from './gbpImages';
import { locationsApi } from './locations';

// -------------------------------------------------------------------
// The single api object (the REAL api/v1 surface), reassembled from the
// per-domain method objects. Same method names + signatures + behavior as
// the former monolithic `export const api`.
// -------------------------------------------------------------------
export const api = {
  ...coreApi,
  ...googleApi,
  ...reviewsApi,
  ...customersApi,
  ...requestsApi,
  ...notificationsApi,
  ...templatesApi,
  ...automationsApi,
  ...accountApi,
  ...widgetApi,
  ...missedCallApi,
  ...competitorsApi,
  ...analyticsApi,
  ...reviewMiningApi,
  ...integrationsApi,
  ...socialApi,
  ...gbpPostsApi,
  ...gbpImagesApi,
  ...locationsApi,
  ...adminApi,
  ...billingApi,
  ...feedbackBoardApi,
  ...smsOptInApi,
};
